import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Link } from "@mui/material";
import Box from "components/common/Box";

export default function DialogConnector({ open, closeConnector }) {
  return (
    <>
      <Dialog
        open={open}
        onClose={closeConnector}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "0px",
          }}
        >
          <img
            style={{ height: "65px" }}
            src="../images/successful.svg"
            alt="logo"
          />
        </DialogContent>
        <DialogContent sx={{ padding: "30px 50px" }}>
          <DialogTitle
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#1A1A1A",
              padding: "0px 10px",
            }}
          >
            Connector added
          </DialogTitle>
          <DialogTitle
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#1A1A1A",
              padding: "0px 20px",
            }}
          >
            successfully.
          </DialogTitle>
        </DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Link href="/connector" sx={{ width: "200px" }}>
            <Button
              variant="contained"
              sx={{
                background: "#04AAD",
                marginRight: "1rem",
                width: "100.17px",
                height: "40px",
                marginBottom: "1.2rem",
                cursor: "pointer",
                width: "200px",
              }}
              onClick={closeConnector}
            >
              ok
            </Button>
          </Link>
        </Box>
      </Dialog>
    </>
  );
}
